import Particles, { initParticlesEngine } from "@tsparticles/react"
import { loadSlim } from "@tsparticles/slim"
import { useEffect, useState } from "react";
import particleconfig from "../components/config/particles-config";
import SiteHeader from '../components/SiteHeader';

export default function ContactPage() {

    const [init, setInit] = useState(false);

    useEffect(() => {
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      }).then(() => {
        setInit(true);
      })
    }, []);
  
    const particlesLoaded = (container) => {
      console.log("Particles loaded:", container);
    };
  
    return (
      <div className="App">
        <SiteHeader />
        {init && (<Particles id="tsparticles" options={particleconfig} particlesLoaded={particlesLoaded}></Particles>)}
      </div>
    );
  }